import type {RouteRecordRaw} from "vue-router";

const authRoutes: RouteRecordRaw[] = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/auth/Login.vue'),
        meta: {
            no_auth: true,
        }
    },
    {
        path: '/google-login',
        name: 'google-login',
        component: () => import('@/views/auth/GoogleLogin.vue'),
        meta: {
            no_auth: true,
        }
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import('@/views/auth/register/SignUp.vue'),
        meta: {
            no_auth: true,
        }
    },
    {
        path: '/invitation',
        name: 'invitation',
        component: () => import('@/views/auth/register/InvitationSignUp.vue'),
        meta: {
            no_auth: true,
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('@/views/auth/Logout.vue'),
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password',
        component: () => import('@/views/auth/forgot-password/ResetPassword.vue'),
        meta: {
            no_auth: true,
        }
    },
    {
        path: '/subscription-redirect/:id(\\d+)',
        name: 'subscription-redirect',
        component: () => import('@/views/auth/SubscriptionRedirection.vue'),
        meta: {
            no_auth: true,
        }
    },
]

export default authRoutes